module.exports = __webpack_public_path__ + "img/1.73e7065c.png";